<template>
  <section>
    <div class="w-100 bg-grey py-5">
      <b-container>
        <b-row class="text-grey text-center">
          <b-col lg="4" class="p-3 p-lg-2">
            <div
              class="h-boxes p-5 bg-white rounded shadow-sm d-flex align-items-center"
            >Tenha acesso a uma plataforma exclusiva e a canais de atendimento online, onde nossos consultores estão a total disposição para fazer o melhor negócio.</div>
          </b-col>

          <b-col lg="4" class="p-3 p-lg-2">
            <div
              class="h-boxes p-5 bg-white rounded shadow-sm d-flex align-items-center"
            >Mande ofertas nos veículos disponíveis de forma rápida e clara. Se o cliente aceitar sua proposta, nós providenciamos toda a documentação na mesma hora!</div>
          </b-col>

          <b-col lg="4" class="p-3 p-lg-2">
            <div
              class="h-boxes p-5 bg-white rounded shadow-sm d-flex align-items-center"
            >Todos nossos carros são periciados antes de você finalizar a compra, e você retira o veículo na mesma hora. Simples, rápido e muito seguro.</div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container>
      <b-row class="py-5">
        <b-col lg="6" class="d-flex justify-content-center flex-column text-purple py-5">
          <h1
            class="font-weight-normal"
            v-html="'São diversos negócios fechados a todo momento, <strong>confira já nosso estoque virtual</strong>'"
          />
          <p>
            Basta se cadastrar
            <strong>gratuitamente</strong> e aproveitar todos os dias
            <strong>centenas de veículos</strong> de procedência e com garantia das condições avaliadas
          </p>
        </b-col>

        <b-col lg="6" class="pb-5">
          <form-shopkeeper class="m-t-negative shadow" />
        </b-col>
      </b-row>
    </b-container>

    <div class="w-100 bg-grey py-5">
      <b-container>
        <b-row class="text-grey text-center">
          <b-col cols="12">
            <h5
              class="font-weight-normal mb-3"
              v-html="'Já são mais de <strong>6.000 lojistas cadastrados</strong>, renovando seus estoques com a VAAPTY Auto Trader, venha fazer parte você também.'"
            />
            <h5
              class="font-weight-normal"
              v-html="'Comprar carros para sua loja ficou <strong>muito mais fácil</strong>.'"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
import FormShopkeeper from "@/components/FormShopKeeper.vue";
export default {
  components: {
    FormShopkeeper
  }
};
</script>

<style lang="scss" scoped>
.h-boxes {
  height: 250px;
}

.m-t-negative {
  margin-top: -4rem;

  @media screen and (max-width: 992px) {
    margin-top: 1rem;
  }
}

.bg-grey {
  background-color: #ebebeb;
}

.text-grey {
  color: #696969;
}
</style>
